import { render, staticRenderFns } from "./AdminMfaPolicySettings.vue?vue&type=template&id=6c84f02f&scoped=true&"
import script from "./AdminMfaPolicySettings.vue?vue&type=script&lang=js&"
export * from "./AdminMfaPolicySettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminMfaPolicySettings.vue?vue&type=style&index=0&id=6c84f02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84f02f",
  null
  
)

export default component.exports